export function isValidNumber(text: string) {
  const number = parseFloat(text);

  if (Number.isNaN(number) || text !== number.toString()) {
    return false;
  }

  return true;
}
